import React from 'react';
import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {CustomField, EmployeeCustomFields, Panel, ActionLink} from 'shared/components';
import {FormattedMessage} from 'react-intl';

const EmptyState = () => {
  return (
    <Panel>
      <Panel.Header title={t('employees.hire.steps.Job Custom Fields')}/>
      <div className='center jumbo rounded h5 py2 px1 Table-emptyState'>
        <FormattedMessage id={'employees.hire.custom_fields.No applicable job custom fields for this employee. To manage custom fields, visit'}/>
        <ActionLink onClick={() => window.open('/company_settings/custom_fields/job', '_blank')}>
          <FormattedMessage id='employees.hire.custom_fields.Company Settings'/>
        </ActionLink>
      </div>
    </Panel>
  );
};

const JobCustomFields = observer(({uiState}) => {
  const {employeeJobCustomFields, errors} = uiState;

  if (employeeJobCustomFields.length === 0) {
    return <EmptyState/>;
  }

  return (
    <EmployeeCustomFields employeeCustomFields={employeeJobCustomFields} category='job' errors={errors} useFormLayout>
      {(employeeCustomField, error) => (
        <CustomField
          customField={employeeCustomField}
          key={employeeCustomField.id}
          errorMessage={error ? error.value : null}
        />
      )}
    </EmployeeCustomFields>
  );
});

export default JobCustomFields;
